export default "__VITE_ASSET__szpQ3xJd__"